import React, { FunctionComponent, useRef, useState } from "react";
import { customApp } from "../config";
import Spacer from "./base/Spacer";
import { Platform, View, ScrollView, Pressable, Text, StyleSheet } from "react-native";
import { WebView } from 'react-native-webview';
import { WebView as WebViewForWeb } from 'react-native-web-webview';
import { ModalFull } from "./elements/ModalFull";
import { base64Encode } from "../utils/general";

export interface ModalGraphProps {
    showMe: boolean;
    setShowMe: Function;
    statusStore: any;
    isPTW?: boolean;
    authenticationStore: any;
    lstForms: any[];
}

export const ModalGraph: FunctionComponent<ModalGraphProps> = ({ showMe, setShowMe, statusStore, isPTW = false, authenticationStore, lstForms }) => {
    const cancelRef = useRef();
    const [graphActive, setGraphActive] = useState(0);

    const formsWithGraph = React.useMemo(() => {
        return lstForms.filter(f => f.graphId != null && f.graphId !== "");
    }, [lstForms]);

    React.useEffect(() => {
        if (showMe) {
            setGraphActive(0);
        }
    }, [showMe]);

    const getGraph = (idx = 0) => {
        const form = formsWithGraph[idx];
        if (!form) return "";
        const token = authenticationStore.userInfo.userToken;
        const url = `app/#/graph/${form.graphId}?departmentId=${form.departmentId}`
        return `${customApp.graphsUrl || customApp.baseUrl}app/loadfromApp.html#${base64Encode("token=".concat(token, "&user=", authenticationStore.userInfo.id, "&url=", url))}`;
    }

    const BodyView = () => {
        const uri = getGraph(graphActive);
        if (!uri) return <></>;

        if (Platform.OS != "web") {
            return <WebView
                key={uri}
                source={{ uri }}
                originWhitelist={['*']}
                injectedJavaScript={`
                                                            const meta = document.createElement('meta');
                                                            meta.setAttribute('content', 'initial-scale=0.5, maximum-scale=1.0, user-scalable=yes');
                                                            meta.setAttribute('name', 'viewport');
                                                            document.head.appendChild(meta);
                                                            document.body.style.zoom = "1";
                                                            true;
                                                          `}
                scalesPageToFit={true}
                style={{
                    width: statusStore.windowDimensions.width,
                    height: (statusStore.windowDimensions.height - 200),
                }}
            />
        } else {
            return (
                <View style={{ flex: 1, overflow: 'hidden' }}>
                    <View style={{
                        width: '117.6%',
                        height: '117.6%',
                        transform: [{ scale: 0.85 }],
                        transformOrigin: 'top left' as any,
                    }}>
                        <WebViewForWeb
                            key={uri}
                            startInLoadingState={true}
                            source={{ uri }}
                            style={{ flex: 1, width: "100%", height: "100%", backgroundColor: "transparent" }}
                            hideStatusBar={false}
                            hideAddressBar={false}
                            javaScriptEnabled={true}
                            originWhitelist={['*']}
                            hideActivityIndicator={false}
                        />
                    </View>
                </View>
            )
        }
    }

    if (showMe == false) return <></>;

    return (
        <ModalFull visible={showMe} closeButton_onPress={() => setShowMe(false)} title={"Tableros Asociados"}>
            <View style={styles.tabBarContainer}>
                <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={styles.tabBarScroll}>
                    {formsWithGraph.map((form, idx) => {
                        const isActive = graphActive === idx;
                        return (
                            <Pressable
                                key={form.id || idx}
                                onPress={() => setGraphActive(idx)}
                                style={[styles.tabButton, isActive && styles.tabButtonActive]}
                            >
                                <Text style={[styles.tabText, isActive && styles.tabTextActive]}>
                                    {form.name}
                                </Text>
                            </Pressable>
                        );
                    })}
                </ScrollView>
            </View>
            <BodyView />
        </ModalFull>
    );
}

const styles = StyleSheet.create({
    tabBarContainer: {
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        backgroundColor: "#fff",
    },
    tabBarScroll: {
        paddingHorizontal: 5,
        paddingVertical: 5,
        flexDirection: "row",
    },
    tabButton: {
        paddingVertical: 4,
        paddingHorizontal: 10,
        borderRadius: 20,
        marginRight: 10,
        backgroundColor: "#f5f5f5",
        borderWidth: 1,
        borderColor: "#d1d0d0ff",
    },
    tabButtonActive: {
        backgroundColor: "#226073",
        borderColor: "#226073",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.2,
        shadowRadius: 3,
        elevation: 3,
    },
    tabText: {
        fontSize: 12,
        color: "#555",
        fontWeight: "500",
    },
    tabTextActive: {
        color: "#fff",
        fontWeight: "bold",
        fontSize: 12.5,
    },
});

